<template>
  <div>
    <PageAllow controller="Shops" action="index" />
    <Breadcrumbs :items="items" />

    <v-slide-x-transition>
      <v-sheet
        v-show="!(currentItemMode || importShopsResultFlg)"
        class="transparent-background-color"
      >
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                ref="keyword"
                v-model="options.keyword"
                @text="shopsKeyword = $event"
                :label="$t('Shop.shopsKeyword', [$consts.shopName()])"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <v-btn
                v-if="settings && settings.sync_hml_data == 1"
                small
                color="warning"
                @click.stop="syncHuaManLouShops()"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-sync</v-icon>
                {{ $t("Shop.actions.syncThirdShop") }}
              </v-btn>
              <v-btn
                small
                color="warning"
                class="ms-1"
                v-if="
                  false && //暂时隐藏无效按钮
                  $permission.permissionAllow('Shops', 'refreshShopAddress')
                "
              >
                <v-icon x-small class="pe-1">fa-sync</v-icon>
                {{ $t("Shop.refreshLocation", [$consts.shopName()]) }}
              </v-btn>
              <v-btn
                v-if="
                  settings &&
                  settings.push_platform != 1018 &&
                  settings.push_platform <= 2000 &&
                  !sync_shop_data_from && // 有三方对接但基础信息以本地录入形式处理
                  $permission.permissionAllow('Shops', 'add')
                "
                small
                color="primary"
                @click.stop="
                  currentItemMode = 'new';
                  currentItem = { id: 0 };
                "
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.newInfo", [$consts.shopName()]) }}
              </v-btn>
              <v-btn
                v-if="
                  settings &&
                  (settings.push_platform == 1018 ||
                    settings.push_platform > 2000 ||
                    sync_shop_data_from) &&
                  $permission.permissionAllow('Shops', 'add')
                "
                small
                dark
                color="warning"
                class="ms-1"
                @click.stop="syncKingdeeShops()"
              >
                <v-icon x-small class="pe-1">fa-sync</v-icon>
                {{ $t("Shop.actions.syncWithKingdee") }}
              </v-btn>
              <v-btn
                v-if="
                  settings &&
                  settings.sync_third_base_shops &&
                  settings.sync_third_base_shops == 1
                "
                small
                dark
                color="warning"
                class="ms-1"
                @click.stop="syncThirdShop()"
              >
                <v-icon x-small class="pe-1">fa-sync</v-icon>
                {{ $t("Shop.actions.syncThirdShop") }}
              </v-btn>
              <!-- 导入门店 -->
              <v-btn
                v-if="$permission.permissionAllow('Shops', 'import')"
                small
                color="print"
                dark
                @click.stop="ImportDialog = true"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-file-import</v-icon>
                {{ $t("Import.import", [$consts.shopName()]) }}
              </v-btn>
              <v-btn
                v-if="$permission.permissionAllow('Shops', 'export')"
                small
                color="print"
                dark
                @click.stop="exportExcel()"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("Export.export", [$consts.shopName()]) }}
              </v-btn>
              <v-btn
                v-if="
                  $permission.permissionAllow(
                    'OrderCycles',
                    'importShopOrderCycle'
                  ) && settings.use_ordercycle
                "
                small
                color="print"
                dark
                @click.stop="orderCycleImportDialog = true"
                class="ms-1"
              >
                <v-icon x-small class="pe-1">fa-file-import</v-icon>
                {{ $t("Shop.shopOrderCycleImport", [$consts.shopName()]) }}
              </v-btn>
              <v-btn
                v-if="settings && settings.push_platform == 1017"
                small
                color="warning"
                dark
                @click.stop="submitBatchPush()"
                class="ms-1"
              >
                {{ $t("Shop.batchPush") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="login_user_id"
                    v-model="options.login_user_id"
                    @text="login_user_id = $event"
                    :label="$t('Shop.shopUserKeyword')"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="
                    $permission.permissionAllow('AllianceBusinesses', 'index')
                  "
                >
                  <SearcherAlliances v-model="alliancesSelected" />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherDistricts v-model="districtsSelected" />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="settings && settings.shop_inventory_enable"
                >
                  <SearcherSelect
                    ref="label"
                    v-model="options.label"
                    :items="labels"
                    :label="$t('Shop.Fields.label', [this.$consts.shopName()])"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherTemplate v-model="templateSelected" />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="shop_user_name"
                    v-model="options.shop_user_name"
                    @text="shopUserNameKeyword = $event"
                    :label="$t('Shop.Fields.shop_user_name')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.pay_settings"
                    :label="$t('Shop.Fields.pay_setting')"
                    :items="
                      $permission.permissionAllow('Shops', 'shopBillDate')
                        ? $consts.shop.pay_settings
                        : $consts.shop.pay_settings.filter(
                            (e) => e.value != 5 && e.value != 6 && e.value != 7
                          )
                    "
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.status"
                    :label="$t('Shop.status.title')"
                    :items="$consts.shop.status"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="settings && settings.shop_contract"
                >
                  <div
                    class="caption grey--text input-chip-group-label"
                    :class="
                      $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                    "
                  >
                    {{ $t("Shop.shopContractStatus.title") }}
                  </div>
                  <v-radio-group row v-model="options.shop_contract_status">
                    <v-radio
                      :label="$t('Shop.shopContractStatus.all')"
                      :key="0"
                      :value="0"
                    />
                    <v-radio
                      :label="$t('Shop.shopContractStatus.notSet')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('Shop.shopContractStatus.in')"
                      :key="2"
                      :value="2"
                    />
                    <v-radio
                      :label="$t('Shop.shopContractStatus.out')"
                      :key="3"
                      :value="3"
                    />
                  </v-radio-group>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="settings && settings.shop_inventory_enable"
                >
                  <div
                    class="caption grey--text input-chip-group-label"
                    :class="
                      $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                    "
                  >
                    {{ $t("Shop.psiSettings.title") }}
                  </div>
                  <v-radio-group row v-model="psiEnable">
                    <v-radio
                      :label="$t('Shop.psiSettings.all')"
                      key="all"
                      value="all"
                    />
                    <v-radio
                      :label="$t('Shop.psiSettings.off')"
                      :key="0"
                      :value="0"
                    />
                    <v-radio
                      :label="$t('Shop.psiSettings.on')"
                      :key="1"
                      :value="1"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="shops"
            :loading="loading"
            :options.sync="options"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-2 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.status="{ item, index }">
              <span :v-resize="!index ? $stickTableResizer() : null"> </span>
              <v-chip
                small
                label
                :color="item.status | shopStatusColor"
                :text-color="item.status | shopStatusTextColor"
              >
                {{ item.status | shopStatusText }}
              </v-chip>
            </template>
            <template v-slot:item.shop_pay_setting="{ item }">
              <v-chip
                small
                label
                :color="item.shop_pay_setting | shopPaySettingsColor"
                :text-color="item.shop_pay_setting | shopPaySettingsTextColor"
              >
                {{ item.shop_pay_setting | shopPaySettingsText }}
              </v-chip>
            </template>
            <template v-slot:item.template_name="{ item }">
              <a
                :href="'/#/templates/' + item.material_template_id"
                style="text-decoration: none"
              >
                {{ item.template_name }}
              </a>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip
                top
                v-if="$permission.permissionAllow('Shops', 'view')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="secondary"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      currentItemMode = 'view';
                      currentItem = item;
                    "
                    >fa-file-alt
                  </v-icon>
                </template>
                <span>{{ $t("CRUD.viewInfo", [$consts.shopName()]) }}</span>
              </v-tooltip>
              <v-tooltip
                top
                v-if="$permission.permissionAllow('Shops', 'edit')"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    class="px-1 py-4 me-1"
                    @click.stop="
                      currentItemMode = 'edit';
                      currentItem = item;
                    "
                    >fa-pencil-alt
                  </v-icon>
                </template>
                <span>{{ $t("CRUD.editInfo", [$consts.shopName()]) }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <ShopDetail
      v-show="currentItemMode"
      v-model="currentItem"
      :mode="currentItemMode"
      v-on:mode="currentItemMode = $event"
      v-on:save="getShopsFromAPI()"
    />
    <ImportShopsResult
      v-show="importShopsResultFlg"
      v-model="importShopsResult"
      v-on:close="
        importShopsResultFlg = false;
        getShopsFromAPI();
      "
    />
    <!-- <v-dialog v-model="ImportDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("Import.import", [$consts.shopName()]) }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="ImportDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-4 py-8 text-center subtitle-1">
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="text-left my-2">
                {{
                  $t("Import.downloadFieldTemplate", [$consts.shopName()])
                }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-btn
                  color="primary"
                  dark
                  class="ms-1"
                  :href="
                    $BaseURL +
                    'download/template/shop_import_template.xls'
                  "
                >
                  {{ $t("Import.downloadFieldTemplateBtn") }}
                </v-btn>
              </v-list-item-subtitle>
              <v-list-item-title class="text-left my-2">
                {{ $t("Import.uploadField", [$consts.shopName()]) }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-file-input
                  v-model="excelFile"
                  show-size
                  :label="$t('Import.fileInputLabel')"
                  accept=".xls,.xlsx"
                ></v-file-input>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="ImportDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="primary" depressed @click="importExcel()">
            {{ $t("Import.confirmImport") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <ImportExcelAlert
      v-model="ImportDialog"
      :objName="$consts.shopName()"
      :downloadTemplateUrl="
        settings && settings.presale_enable
          ? settings && settings.shop_contract
            ? 'download/template/shop_import_template_two_presale.xls'
            : 'download/template/shop_import_template_presale.xls'
          : settings && settings.shop_contract
          ? 'download/template/shop_import_template_two.xls'
          : 'download/template/shop_import_template.xls'
      "
      @import="
        excelFile = $event;
        importExcel();
      "
    />
    <ImportExcelAlert
      v-model="orderCycleImportDialog"
      :objName="$t('Shop.shopOrderCycle', [$consts.shopName()])"
      downloadFromAPI
      @download="exportOrderCycleExport()"
      @import="
        excelOrderCycleFile = $event;
        importOrderCycleExcel();
      "
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Shops from "@/api/shops";
import OrderCycles from "@/api/order_cycles";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherTemplate from "@/components/plugins/SearcherTemplate";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherDistricts from "@/components/plugins/SearcherDistricts";
import SearcherAlliances from "@/components/plugins/SearcherAlliances";
import ShopDetail from "./plugins/Detail";
import ImportShopsResult from "./plugins/importShopsResult";
import ImportExcelAlert from "@/components/plugins/ImportExcelAlert";
import KingdeeWorker from "@/api/kingdee_worker";
import YywdMiddleware from "@/api/yywd_middleware";
import YywdNewMiddleware from "@/api/yywd_new_middleware";
import SearcherSelect from "@/components/plugins/SearcherSelect";

const defaultOptions = {
  keyword: "",
  shop_user_name: "",
  login_user_id: "",
  alliance_business_ids: [],
  status: [0, 1, 2, 3],
  // reg_flg: [0, 1],
  district_codes: [],
  template_id: "",
  shop_contract_status: 0,
  label: "",
  pay_settings: [1, 2, 3, 4, 5, 6, 7],
  sortBy: [],
  sortDesc: []
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherStatus,
    SearcherTemplate,
    SearcherKeyword,
    SearcherDistricts,
    SearcherAlliances,
    ShopDetail,
    ImportExcelAlert,
    ImportShopsResult,
    SearcherSelect,
  },

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.shopManagement", [this.$consts.shopName()]),
          disabled: false,
          href: "/shops",
        },
        {
          text: i18n.t("Nav.shops", [this.$consts.shopName()]),
          disabled: true,
          href: "/shops",
        },
      ];
    },
    headers() {
      return [
        {
          text: i18n.t("Shop.Fields.shop_code", [this.$consts.shopName()]),
          align: "start",
          sortable: true,
          class: "text-no-wrap",
          value: "shop_code",
        },
        {
          text: i18n.t("Shop.Fields.shop_name", [this.$consts.shopName()]),
          align: "start",
          sortable: true,
          class: "text-no-wrap",
          value: "shop_name",
        },
        {
          text: i18n.t("Shop.Fields.shop_district"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "district.name",
        },
        {
          text: i18n.t("Shop.Fields.shop_user_name"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "shop_user.name",
        },
        {
          text: i18n.t("Shop.Fields.template"),
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "template_name",
        },
        {
          text: i18n.t("Shop.Fields.pay_setting"),
          align: "start",
          sortable: true,
          class: "text-no-wrap",
          value: "shop_pay_setting",
        },
        {
          text: i18n.t("Shop.Fields.status"),
          align: "center",
          sortable: true,
          class: "text-no-wrap",
          value: "status",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "actions",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState([
      "loading",
      "stickTableCols",
      "settings",
      "sync_shop_data_from",
    ]),
  },

  mounted() {
    Shops.fetchLabels().then(
      function (response) {
        if (response.data.status.isOK()) {
          this.labels = response.data.label;
        }
      }.bind(this)
    );

    this.$commonUtils
      .loadOptions("shops", [
        "alliancesSelected",
        "districtsSelected",
        "templateSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
            if (this.options.psi_enable != undefined) {
              if (this.options.psi_enable === "") {
                this.psiEnable = "all";
              } else {
                this.psiEnable = this.options.psi_enable;
              }
            }
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "alliancesSelected":
                this.alliancesSelected = selected.value;
                break;
              case "districtsSelected":
                this.districtsSelected = selected.value;
                break;
              case "templateSelected":
                this.templateSelected = this.$route.query.template_id
                  ? { id: this.$route.query.template_id }
                  : selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  data: () => ({
    shops: [],
    shopsKeyword: "",
    shopUserNameKeyword: "",
    alliancesSelected: [],
    districtsSelected: [],
    templateSelected: null,
    options: JSON.parse(
      sessionStorage.getItem("shops-options")
        ? sessionStorage.getItem("shops-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    currentItemMode: null,
    currentItem: null,
    ImportDialog: false,
    excelFile: null,
    importShopsResultFlg: false,
    importShopsResult: [],
    orderCycleImportDialog: false,
    excelOrderCycleFile: null,
    psiEnable: "all",
    labels: [],
  }),

  methods: {
    resetSearch() {
      this.alliancesSelected = [];
      this.districtsSelected = [];
      this.templateSelected = null;
      this.psiEnable = "all";
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.keyword, this.$refs.shop_user_name, this.$refs.login_user_id, this.$refs.label].forEach(
        (k) => {
          if (k) k.clear();
        }
      );
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        keyword: this.shopsKeyword,
        shop_user_name:this.shopUserNameKeyword,
        login_user_id: this.login_user_id,
      });
    },
    getShopsFromAPI() {
      if (this.settings && !this.settings.shop_contract) {
        delete this.options.shop_contract_status;
      }
      Shops.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shops = response.data.shops;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    exportExcel() {
      if (this.settings && !this.settings.shop_contract) {
        delete this.options.shop_contract_status;
      }
      Shops.exports(this.options);
    },
    exportOrderCycleExport() {
      if (this.settings && !this.settings.shop_contract) {
        delete this.options.shop_contract_status;
      }
      OrderCycles.exports(this.options);
    },
    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      Shops.imports(this.excelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              if (response.data.data && response.data.data.length) {
                this.ImportDialog = false;
                this.importShopsResultFlg = true;
                this.importShopsResult = response.data.data;
              } else {
                this.$snackbar.info(
                  i18n.t("Import.success", [this.$consts.shopName()])
                );
                this.ImportDialog = false;
                this.getShopsFromAPI();
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    importOrderCycleExcel() {
      this.$store.dispatch("fullscreenLoading");
      OrderCycles.imports(this.excelOrderCycleFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              if (response.data.data && response.data.data.length) {
                this.orderCycleImportDialog = false;
                this.importShopsResultFlg = true;
                this.importShopsResult = response.data.data;
              } else {
                this.$snackbar.info(
                  i18n.t("Import.success", [this.$consts.shopName()])
                );
                this.orderCycleImportDialog = false;
                this.getShopsFromAPI();
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    submitBatchPush() {
      Shops.fpBatchPush().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(i18n.t("Shop.batchPushSuccess"));
          }
        }.bind(this)
      );
    },
    syncKingdeeShops() {
      this.$store.dispatch("fullscreenLoading");
      if (this.settings.push_platform == 1018)
        KingdeeWorker.addJob({
          event: "sync_shops",
          param: { sync_time: this.$datetimeUtils.formatTime(new Date()) },
        }).then(
          function (response) {
            if (response) {
              if (response.data.status.isOK()) {
                this.$snackbar.success(i18n.t("Shop.syncWithKingdee"));
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
      else if (this.sync_shop_data_from > 0) {
        var ev = null;
        switch (this.sync_shop_data_from) {
          case 1: // 金蝶
          case 2: // 用户自行注册
            ev = "sync_kingdee_shops";
            break;
        }
        if (ev == null) return; //万一有配置错误就不推送任务了
        YywdNewMiddleware.addJob({
          event: ev,
          param: { sync_time: this.$datetimeUtils.formatTime(new Date()) },
        }).then(
          function (response) {
            if (response) {
              if (response.data.status.isOK()) {
                this.$snackbar.success(i18n.t("Shop.syncWithKingdee"));
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
      } else
        YywdMiddleware.addJob({
          event: "sync_shops",
          param: { sync_time: this.$datetimeUtils.formatTime(new Date()) },
        }).then(
          function (response) {
            if (response) {
              if (response.data.status.isOK()) {
                this.$snackbar.success(i18n.t("Shop.syncWithKingdee"));
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    syncThirdShop() {
      this.$store.dispatch("fullscreenLoading");
      Shops.syncThirdShop()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.success(i18n.t("Shop.syncThirdShop"));
              this.getShopsFromAPI();
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    syncHuaManLouShops() {
      this.$store.dispatch("fullscreenLoading");
      Shops.syncHuaManLouShops()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getShopsFromAPI(); // 同步成功的话刷新数据
              this.$snackbar.success(i18n.t("Shop.syncThirdShop"));
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
  },

  watch: {
    $route() {
      if (!this.$route.query.id) {
        this.currentItemMode = null;
        this.currentItem = null;
      }
    },
    settings: {
      handler() {
        if (this.settings && !this.settings.shop_contract) {
          delete this.options.shop_contract_status;
        }
      },
    },
    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$router.replace("/shops?id=" + this.currentItem.id);
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
          this.$router.replace("/shops");
        }
      },
    },
    options: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getShopsFromAPI();
        sessionStorage.setItem("shops-options", JSON.stringify(this.options));
      },
    },
    districtsSelected: {
      handler() {
        this.options.district_codes = this.districtsSelected
            ? this.districtsSelected.map((district) => {
              return district.code;
            })
            : [];
        sessionStorage.setItem(
          "shops-districtsSelected",
          JSON.stringify(this.districtsSelected)
        );
      },
    },
    templateSelected: {
      handler() {
        if (this.$route.query.template_id && !this.templateSelected) {
          this.$router.replace("/shops");
        }
        this.options.template_id = this.templateSelected
          ? this.templateSelected.id
          : "";
        sessionStorage.setItem(
          "shops-templateSelected",
          JSON.stringify(this.templateSelected)
        );
      },
    },
    alliancesSelected: {
      //加盟商搜索
      handler() {
        this.options.alliance_business_ids = this.alliancesSelected
          ? this.alliancesSelected.map((alliance) => {
              return alliance.id;
            })
          : [];
        sessionStorage.setItem(
          "shops-alliancesSelected",
          JSON.stringify(this.alliancesSelected)
        );
      },
    },
    ImportDialog: {
      handler() {
        if (!this.ImportDialog && this.excelFile) {
          this.excelFile = null;
        }
      },
    },
    psiEnable: {
      handler() {
        if (this.psiEnable == "all") {
          this.options.psi_enable = "";
        } else {
          this.options.psi_enable = this.psiEnable;
        }
        this.getShopsFromAPI();
        sessionStorage.setItem("shops-options", JSON.stringify(this.options));
      },
    },
  },
};
</script>